import { URL_REPLACEMENT } from '$const';
import { get } from '~services/api/methods';

export async function fetchSearchResults(realm: string, query = '', idCollection = '', start = 0) {
  const params = new URLSearchParams(query);
  if (start > 0) {
    params.append('start', `${start}`);
  }
  if (!!idCollection) {
    params.append('Collections', idCollection);
  }
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/search_result/${realm}?${params}`;
  // decode url, to prevent dopple encoding, by api get method
  const response = await get(decodeURIComponent(requestUrl));
  return response;
}
